import { icons } from "@shane-collective/design-system/dist/icons";
import ReactGA from "react-ga4";

//@ts-ignore
export const mapboxToken: string = process.env.REACT_APP_MAPBOX_TOKEN ?? "";
export const mapboxStyle: string =
  "mapbox://styles/caz-shanecollective/cm9lip57k006401sbgcky4u7y";

export const userMarkerColor = "#6447C6";

export const clustersEnabled = true;
export const showAllZoomLevel = 14;
export const pageSize = 25;
export const reviewsPageSize = 10;
export const runInDummyDataMode = false;

export const pwaPromptLocalStorageKey = "ShanePWA";
export const appSettingsLocalStorageKey = "ShaneSettings";
export const appProfileLocalStorageKey = "ShaneProfile";
export const defaultAppSettings = { "Show ratings on map": true };
export const locationPermissionsLocalStorageKey = "ShaneHome";
export const recaptchaTimestampSessionStorageKey = "ShaneRC";

//@ts-ignore
export const baseApiUrl = process.env.REACT_APP_BASE_API_URL;

export const writeToLog = (logItems: unknown[] | unknown) => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("debug") && urlParams.get("debug") === "true") {
    const itemsArray = Array.isArray(logItems) ? logItems : [logItems]; // Ensure it's always an array
    console.log(
      "[SHANE WEB APP]",
      ...itemsArray.concat(new Date().toISOString())
    );
  }
};

export const defaultSelectedFilters = [];
export const defaultSelectedFeatures = [];

export const defaultLat = 41.9028;
export const defaultLng = 12.4964;

export const refugeRestroomsCategory = "Gender-Inclusive Toilets";
export const mapHiddenWhereCategory = "Online only";

export const markerMapping: any[] = [
  {
    isCertified: false,
    isRatingMode: true,
    isShaneLocation: true,
    className: "marker-rating",
  },
  {
    isCertified: false,
    isRatingMode: true,
    isShaneLocation: false,
    className: "marker-rating-20",
  },
  {
    isCertified: true,
    isRatingMode: true,
    isShaneLocation: true,
    className: "marker-rating-star",
  },
  {
    isCertified: true,
    isRatingMode: false,
    isShaneLocation: true,
    className: "marker-star",
  },
  {
    isCertified: false,
    isRatingMode: false,
    isShaneLocation: true,
    className: "marker",
  },
  {
    isCertified: false,
    isRatingMode: false,
    isShaneLocation: false,
    className: "marker-20",
  },
];

export const externalSources = [
  {
    key: "refuge-restrooms",
    displayName: "Refuge Restrooms",
    marker: "marker-rr",
  },
  { key: "osm", displayName: "OpenStreetMap", marker: "marker-osm" },
  { key: "qiekub", displayName: "QueerMap by qiekub", marker: "marker-qiekub" },
  { key: "iglta", displayName: "IGLTA", marker: "marker-iglta" },
  { key: "centerlink", displayName: "Centerlink", marker: "marker-centerlink" },
  {
    key: "gla-london",
    displayName: "Greater London Authority",
    marker: "marker-gla",
  },
];

export const databaseGenders: { id: number; name: string }[] = [
  { id: 1, name: "Woman" },
  { id: 2, name: "Man" },
  { id: 3, name: "Transgender" },
  { id: 4, name: "Non-binary" },
  { id: 5, name: "Gender non-conforming" },
  { id: 6, name: "Bigender" },
  { id: 7, name: "Cisgender" },
  { id: 8, name: "Genderfluid" },
];

export const databaseOrientations = [
  { id: 1, name: "Lesbian" },
  { id: 2, name: "Gay" },
  { id: 3, name: "Ace / Asexual spectrum" },
  { id: 4, name: "Bisexual" },
  { id: 5, name: "Pansexual" },
  { id: 6, name: "Queer" },
  { id: 7, name: "Straight" },
  { id: 8, name: "Fluid" },
];

export const questionResponseMapping = [
  {
    key: "diverseDietaryNeeds",
    question: "Does this accommodate diverse dietary needs?",
  },
  { key: "childFriendly", question: "Does this cater well to families?" },
  {
    key: "accessible",
    question: "Is this accessible for folks with disabilities?",
  },
  {
    key: "genderInclusivity",
    question: "Does this provide gender-inclusive features?",
  },
];

export const defaultResponses = {
  ratings: [
    {
      label: "Overall Safety",
      rating: 0,
      tooltip: "How safe did you feel here?",
    },
    {
      label: "People & Atmosphere",
      rating: 0,
      tooltip: "How friendly and inclusive were the people?",
    },
    {
      label: "Inclusive Facilities",
      rating: 0,
      tooltip: "How accessible and inclusive were the amenities?",
    },
    {
      label: "Trans Inclusivity",
      rating: 0,
      tooltip: "How welcoming and accommodating was the space for trans folks?",
    },
    {
      label: "Visible Allyship",
      rating: 0,
      tooltip:
        "How visibly supportive was this location (e.g. pride flags, inclusive signage)?",
    },
  ],
};

export const sentryDsn =
  "https://0a6441c2d1c379a33bfe6fd29c4de0b8@o4509072783179776.ingest.de.sentry.io/4509072981622864";
export const gaTrackingId = "G-TEXK038ZH1";

export const writeToGA4 = (source: string, event: string, params?: any) => {
  //@ts-ignore
  if (process.env.REACT_APP_ENVIRONMENT === "production") {

    const eventParams = {
      ...params,
      category: "User",
      source,
    };

    ReactGA.event(event, eventParams);

    writeToLog(["[GA4] sent custom event", event, JSON.stringify(eventParams)]);
  }
};

export const features = [
  "Shane certified",
  "LGBTQ+ led*",
  "Trans friendly",
  "Accessible",
  "Caters to families",
  "Accommodates dietary needs",
  "Gender-inclusive features",
];

export const helpLinks = [
  { name: "Frequently asked questions", url: "https://getshane.io/faq" },
  {
    name: "Report a bug",
    url: "https://shanecollective.typeform.com/to/FNNvDBeT",
  },
  { name: "Privacy policy", url: "https://getshane.io/privacy-policy" },
  { name: "Terms of service", url: "https://getshane.io/terms-of-service" },
  {
    name: "Acceptable use policy",
    url: "https://getshane.io/acceptable-use-policy",
  },
  {
    name: "Community guidelines",
    url: "https://getshane.io/community-guidelines",
  },
];

export const subfeatures = [
  {
    feature: "Accessible",
    subfeatures: [
      { option: "Mobility access", tag: "mobility access" },
      { option: "Service animal friendly", tag: "service animals" },
      { option: "Accessible toilets", tag: "accessible toilet" },
      { option: "Sensory accessibility", tag: "sensory access" },
      { option: "Communication accessibility", tag: "comm. access" },
      { option: "Accessible parking & entry", tag: "access. parking & entry" },
      { option: "Emergency preparedness", tag: "emergency ready" },
    ],
  },
  {
    feature: "Caters to families",
    subfeatures: [
      { option: "Stroller accessibility", tag: "stroller access" },
      { option: "High Chair Availability", tag: "high chair access" },
      { option: "Inclusive Changing Tables", tag: "inclusive changing" },
      { option: "Kid-Friendly Menu", tag: "kids' menu" },
      { option: "Safe Play Area", tag: "play area" },
      { option: "Family-Friendly Atmosphere", tag: "family friendly" },
      { option: "Kids’ Entertainment", tag: "kids' fun" },
      { option: "Private Nursing Areas", tag: "nursing areas" },
    ],
  },
  {
    feature: "Accommodates dietary needs",
    subfeatures: [
      { option: "Vegan Options", tag: "vegan" },
      { option: "Gluten-Free Options", tag: "gluten-free" },
      { option: "Allergen Information", tag: "allergen info" },
      { option: "Ingredient Transparency", tag: "ingredient info" },
      { option: "Kid-Friendly Dietary Options", tag: "kids' diets" },
      { option: "Sustainable or Local Sourcing", tag: "sustainable sourcing" },
    ],
  },
  {
    feature: "Gender-inclusive features",
    subfeatures: [
      { option: "Gender-Inclusive Toilet", tag: "inclusive toilet" },
      { option: "Gender-Inclusive Spaces", tag: "inclusive spaces" },
      { option: "Pronoun-Friendly", tag: "pronoun-friendly" },
      { option: "Non-Binary Options", tag: "non-binary" },
      { option: "Inclusive Policies", tag: "inclusive policies" },
    ],
  },
];

export const whatCategories = [
  {
    icon: "FoodDrink2Icon" as keyof typeof icons,
    label: "Food, Drink & Nightlife",
  },
  {
    icon: "Travel2Icon" as keyof typeof icons,
    label: "Travel & Accommodation",
  },
  {
    icon: "Shopping2Icon" as keyof typeof icons,
    label: "Shopping & Personal Services",
  },
  {
    icon: "HealthHeartRateIcon" as keyof typeof icons,
    label: "Health & Wellness",
  },
  {
    icon: "CrownIcon" as keyof typeof icons,
    label: "Shane Certified",
  },
  {
    icon: "GenderNeutralBathroomIcon" as keyof typeof icons,
    label: "Gender-Inclusive Toilets",
  },
  {
    icon: "EntertainmentLeisure3Icon" as keyof typeof icons,
    label: "Entertainment & Leisure",
  },
  {
    icon: "CommunityAndEducationIcon" as keyof typeof icons,
    label: "Education & Community",
  },
  {
    icon: "ProServices2Icon" as keyof typeof icons,
    label: "Professional & Online Services",
  },
  {
    icon: "Government2Icon" as keyof typeof icons,
    label: "Public Services & Government",
  },
  {
    icon: "RatedLocationIcon" as keyof typeof icons,
    label: "All Shane-Rated Places",
  },
  {
    icon: "OtherIcon" as keyof typeof icons,
    label: "Other",
  },
];
export const whereCategories = [
  { icon: "NearMeIcon" as keyof typeof icons, label: "Near me" },

  {
    icon: "MapIcon" as keyof typeof icons,
    label: "This area",
  },
  { icon: "AnywhereIcon" as keyof typeof icons, label: "Anywhere" },
  {
    icon: "SomewhereSpecificIcon" as keyof typeof icons,
    label: "Somewhere specific",
    showInput: true,
  },
  {
    icon: "OnlineOnlyIcon" as keyof typeof icons,
    label: "Online only",
  },
];
export const whatSubCategories = [
  {
    category: "Food, Drink & Nightlife",
    items: [
      {
        icon: "CoffeeIcon" as keyof typeof icons,
        label: "Restaurants & Coffee Shops",
      },
      {
        icon: "BarsAndNightclubsIcon" as keyof typeof icons,
        label: "Bars & Nightclubs",
      },
      {
        icon: "BakeriesAndFoodStoresIcon" as keyof typeof icons,
        label: "Bakeries & Food Stores",
      },
      {
        icon: "BreweryIcon" as keyof typeof icons,
        label: "Breweries & Wineries",
      },
      {
        icon: "OnlineFoodServicesIcon" as keyof typeof icons,
        label: "Online Food Services",
        isOnlineOnly: true,
      },
    ],
  },
  {
    category: "Entertainment & Leisure",
    items: [
      {
        icon: "PerformanceVenuesIcon" as keyof typeof icons,
        label: "Performance Venues",
      },
      {
        icon: "CinemaIcon" as keyof typeof icons,
        label: "Cinemas",
      },
      {
        icon: "MuseumsAndArtGalleriesIcon" as keyof typeof icons,
        label: "Museums & Art Galleries",
      },
      {
        icon: "FestivalsAndEventsIcon" as keyof typeof icons,
        label: "Festivals & Events",
      },
      {
        icon: "ParksAndRecreationAreasIcon" as keyof typeof icons,
        label: "Parks & Recreation Areas",
      },
      {
        icon: "GamingAndArcadesIcon" as keyof typeof icons,
        label: "Gaming & Arcades",
      },
      {
        icon: "SportsAndClubs2Icon" as keyof typeof icons,
        label: "Sports & Clubs",
      },
      {
        icon: "ArtistsIcon" as keyof typeof icons,
        label: "Artists",
      },
      {
        icon: "OnlineEntertainment2Icon" as keyof typeof icons,
        label: "Online Entertainment",
        isOnlineOnly: true,
      },
      { icon: "AttractionsIcon" as keyof typeof icons, label: "Attractions" },
    ],
  },

  {
    category: "Travel & Accommodation",
    items: [
      {
        icon: "HotelsAndHostelsIcon" as keyof typeof icons,
        label: "Hotels, Hostels, B&Bs",
      },
      {
        icon: "VacationRentalsIcon" as keyof typeof icons,
        label: "Vacation Rentals",
      },
      {
        icon: "TravelAgenciesAndGuidesIcon" as keyof typeof icons,
        label: "Travel Agencies & Guides",
      },
      {
        icon: "TransportationServicesIcon" as keyof typeof icons,
        label: "Transportation Services",
      },
      {
        icon: "Airport2Icon" as keyof typeof icons,
        label: "Airports & Stations",
      },
      {
        icon: "OnlineTravelServicesIcon" as keyof typeof icons,
        label: "Online Travel Services",
        isOnlineOnly: true,
      },
    ],
  },
  {
    category: "Shopping & Personal Services",
    items: [
      {
        icon: "ClothingAndAccessoriesIcon" as keyof typeof icons,
        label: "Clothing & Accessories",
      },
      {
        icon: "Electronics2Icon" as keyof typeof icons,
        label: "Electronics & Gadgets",
      },
      {
        icon: "GroceryStoresAndMarketsIcon" as keyof typeof icons,
        label: "Grocery Stores & Markets",
      },
      {
        icon: "HairBeautyAndTattoosIcon" as keyof typeof icons,
        label: "Hair, Beauty & Tattoos",
      },
      {
        icon: "Home3Icon" as keyof typeof icons,
        label: "Home & Lifestyle Stores",
      },
      {
        icon: "Bookstore2Icon" as keyof typeof icons,
        label: "Bookstores & Stationery",
      },
      {
        icon: "OnlineRetailIcon" as keyof typeof icons,
        label: "Online Retail & Marketplaces",
        isOnlineOnly: true,
      },
      {
        icon: "FreelanceIcon" as keyof typeof icons,
        label: "Freelancers & Independent Services",
      },
      {
        icon: "OtherIcon" as keyof typeof icons,
        label: "Other",
      },
    ],
  },
  {
    category: "Health & Wellness",
    items: [
      {
        icon: "GP2Icon" as keyof typeof icons,
        label: "General Practitioners",
      },
      {
        icon: "MedicalSpecialistIcon" as keyof typeof icons,
        label: "Medical Specialists",
      },
      {
        icon: "MentalHealth3Icon" as keyof typeof icons,
        label: "Mental Health Services",
      },
      {
        icon: "HospitalsAndClinicsIcon" as keyof typeof icons,
        label: "Hospitals & Clinics",
      },
      { icon: "PharmaciesIcon" as keyof typeof icons, label: "Pharmacies" },
      {
        icon: "Gym2Icon" as keyof typeof icons,
        label: "Fitness Centers & Gyms",
      },
      {
        icon: "WellnessAndSpaServicesIcon" as keyof typeof icons,
        label: "Wellness & Spa Services",
      },
      {
        icon: "AlternativeMedicinesIcon" as keyof typeof icons,
        label: "Alternative Medicine",
      },
      {
        icon: "OnlineHealthServicesIcon" as keyof typeof icons,
        label: "Online Health Services",
        isOnlineOnly: true,
      },
    ],
  },

  {
    category: "Education & Community",
    items: [
      {
        icon: "University2Icon" as keyof typeof icons,
        label: "Schools & Universities",
      },
      {
        icon: "ChildcareServicesIcon" as keyof typeof icons,
        label: "Childcare services",
      },
      {
        icon: "Community2Icon" as keyof typeof icons,
        label: "Community Organizations",
      },
      { icon: "Library2Icon" as keyof typeof icons, label: "Libraries" },
      {
        icon: "WorkshopsAndTrainingIcon" as keyof typeof icons,
        label: "Workshops & Training",
      },
      {
        icon: "OnlineEducationIcon" as keyof typeof icons,
        label: "Online Education",
        isOnlineOnly: true,
      },
    ],
  },
  {
    category: "Professional & Online Services",
    items: [
      {
        icon: "Law2Icon" as keyof typeof icons,
        label: "Legal Services",
      },
      {
        icon: "FinancialServicesIcon" as keyof typeof icons,
        label: "Financial Services",
      },
      {
        icon: "RealEstateServicesIcon" as keyof typeof icons,
        label: "Real Estate Services",
      },
      {
        icon: "Photo2Icon" as keyof typeof icons,
        label: "Photography & Videography",
      },
      {
        icon: "EventPlanningIcon" as keyof typeof icons,
        label: "Event Planning Services",
      },
      {
        icon: "OnlineProfessionalServicesIcon" as keyof typeof icons,
        label: "Online Professional Services",
        isOnlineOnly: true,
      },
      {
        icon: "OtherIcon" as keyof typeof icons,
        label: "Other",
      },
    ],
  },

  {
    category: "Public Services & Government",
    items: [
      {
        icon: "Police2Icon" as keyof typeof icons,
        label: "Police & Emergency Services",
      },
      {
        icon: "GovBuilding2Icon" as keyof typeof icons,
        label: "Government Offices",
      },
      {
        icon: "PostOfficesIcon" as keyof typeof icons,
        label: "Post Offices",
      },
      {
        icon: "SocialServicesIcon" as keyof typeof icons,
        label: "Social Services",
      },
      {
        icon: "PublicTransportationIcon" as keyof typeof icons,
        label: "Public Transportation",
      },
      {
        icon: "EmbassiesIcon" as keyof typeof icons,
        label: "Embassies & Consulates",
      },
      {
        icon: "OnlinePublicServicesIcon" as keyof typeof icons,
        label: "Online Public Services",
        isOnlineOnly: true,
      },
    ],
  },
];

export const filters = [
  {
    icon: "GenderNeutralBathroomIcon" as keyof typeof icons,
    label: "Gender-inclusive toilets",
  },
  //! temporarily hidden until we have a way to get this data
  // {
  //   icon: "OpenNowIcon" as keyof typeof icons,
  //   label: "Open now",
  // },
  {
    icon: "CrownIcon" as keyof typeof icons,
    label: "Shane certified",
  },
  {
    icon: "LgbtqOwnedIcon" as keyof typeof icons,
    label: "LGBTQ+ led",
  },
  {
    icon: "TransFriendlyIcon" as keyof typeof icons,
    label: "Trans friendly",
  },
  {
    icon: "AllFiltersIcon" as keyof typeof icons,
    label: "All filters",
  },
];

export const getIconForCategory = (categoryName: string) => {
  // get icon from category
  let item = whatSubCategories
    .flatMap((category) => category.items)
    .find((item) => item.label === categoryName);

  if (item) {
    return icons[item.icon];
  } else {
    //see if we can find it in whatCategories
    item = whatCategories.find((c) => c.label === categoryName);
    if (item) {
      return icons[item.icon];
    } else {
      return icons["LocationPinIcon"];
    }
  }
};

export const isWhatSubcategory = (categoryName: string) => {
  //returns what parent category this category is a member of, or undefined if it's a parent category itself

  const result = whatSubCategories.find((categoryGroup) =>
    categoryGroup.items.some((item) => item.label === categoryName)
  );

  return result;
};

export const genders = [
  { label: "Woman", icon: "WomanFlag" as keyof typeof icons },
  { label: "Man", icon: "ManFlag" as keyof typeof icons },
  { label: "Transgender", icon: "TransgenderFlag" as keyof typeof icons },
  { label: "Non-binary", icon: "NonbinaryFlag" as keyof typeof icons },
  {
    label: "Gender non-conforming",
    icon: "GenderNonConformingFlag" as keyof typeof icons,
  },
  { label: "Bigender", icon: "BigenderFlag" as keyof typeof icons },
  { label: "Cisgender", icon: "CisgenderFlag" as keyof typeof icons },
  { label: "Genderfluid", icon: "GenderfluidFlag" as keyof typeof icons },
];
export const orientations = [
  { label: "Lesbian", icon: "LesbianFlag" as keyof typeof icons },
  { label: "Gay", icon: "GayFlag" as keyof typeof icons },
  {
    label: "Ace / Asexual spectrum",
    icon: "AsexualFlag" as keyof typeof icons,
  },
  { label: "Bisexual", icon: "BisexualFlag" as keyof typeof icons },
  { label: "Pansexual", icon: "PansexualFlag" as keyof typeof icons },
  { label: "Queer", icon: "LgbtFlag" as keyof typeof icons },
  { label: "Straight", icon: "StraightFlag" as keyof typeof icons },
  { label: "Fluid", icon: "FluidFlag" as keyof typeof icons },
];

export const INSTANT_SEARCH_INDEX_NAME = 'locations_index';
export const INSTANT_SEARCH_QUERY_SUGGESTIONS =
  'locations_index_query_suggestions';
export const INSTANT_SEARCH_HIERARCHICAL_ATTRIBUTES = [
  'parentCategory','category'
];
